import ComponentFromProp from '../component-from-prop'
import { withClass } from '../../utils'
import styles from './styles.styl'
import { Fb, FbIntro, Tw, TwIntro, Ig, IgIntro, Yt, YtIntro, Li, LiIntro, Pc, PcIntro, Tk } from '../icons'

const IconBox = withClass(styles.icon)('a')
const Icon = ({ as, ...rest }) => (
  <IconBox target='_blank' rel='noopener noreferrer' {...rest} >
    <ComponentFromProp as={as} width='100%' height='100%' />
  </IconBox>
)

export const FbIcon = () => <Icon as={Fb} className={styles.fb} href='http://facebook.com/FutureLondonAcademy' aria-label='Facebook' />
export const FbIntroIcon = () => <Icon as={FbIntro} className={styles.fbIntro} href='http://facebook.com/FutureLondonAcademy' aria-label='Facebook' />
export const TwIcon = () => <Icon as={Tw} className={styles.tw} href='https://twitter.com/flondonacademy' aria-label='Twitter' />
export const TwIntroIcon = () => <Icon as={TwIntro} className={styles.twIntro} href='https://twitter.com/flondonacademy' aria-label='Twitter' />
export const IgIcon = () => <Icon as={Ig} className={styles.ig} href='https://www.instagram.com/futurelondonacademy' aria-label='Instagram' />
export const IgIntroIcon = () => <Icon as={IgIntro} className={styles.igIntro} href='https://www.instagram.com/futurelondonacademy' aria-label='Instagram' />
export const YtIcon = () => <Icon as={Yt} className={styles.yt} href='https://www.youtube.com/futurelondonacademy' aria-label='Youtube' />
export const YtIntroIcon = () => <Icon as={YtIntro} className={styles.ytIntro} href='https://www.youtube.com/futurelondonacademy' aria-label='Youtube' />
export const LiIcon = () => <Icon as={Li} className={styles.li} href='https://www.linkedin.com/company/future-london-academy' aria-label='Linkedin' />
export const LiIntroIcon = () => <Icon as={LiIntro} className={styles.liIntro} href='https://www.linkedin.com/company/future-london-academy' aria-label='Linkedin' />
export const TkIcon = () => <Icon as={Tk} className={styles.tk} href='https://www.tiktok.com/@futurelondonacademy' aria-label='Tiktok' />
export const PcIcon = () => <Icon as={Pc} className={styles.pc} href='https://podcasters.spotify.com/pod/show/creativecapes' aria-label='Spotify' />
export const PcIntroIcon = () => <Icon as={PcIntro} className={styles.pcIntro} href='https://podcasters.spotify.com/pod/show/creativecapes' aria-label='Spotify' />

export default Icon



// WEBPACK FOOTER //
// ./components/social/index.js